// TODO: Move services data from App.tsx here
import { GlobeAmericasIcon, SparklesIcon, MapPinIcon, WrenchScrewdriverIcon, DocumentCheckIcon } from '@heroicons/react/24/outline';
import { GiCargoShip } from 'react-icons/gi';

export const services = [
  {
    icon: GlobeAmericasIcon,
    titleKey: 'services.equipment',
    descriptionKey: 'services.equipmentDesc'
  },
  {
    icon: SparklesIcon,
    titleKey: 'services.refurbishment',
    descriptionKey: 'services.refurbishmentDesc'
  },
  {
    icon: GiCargoShip,
    titleKey: 'services.shipping',
    descriptionKey: 'services.shippingDesc'
  },
  {
    icon: DocumentCheckIcon,
    titleKey: 'services.import',
    descriptionKey: 'services.importDesc'
  },
  {
    icon: MapPinIcon,
    titleKey: 'services.implementation',
    descriptionKey: 'services.implementationDesc'
  },
  {
    icon: WrenchScrewdriverIcon,
    titleKey: 'services.support',
    descriptionKey: 'services.supportDesc'
  }
];
